import GeorgeRansom from "assets/images/psp/review-george.png";
import AnnAlarcon from "assets/images/psp/review-ann.png";
import SMurphy from "assets/images/psp/review-murphy.png";
import Related1 from "assets/images/psp/relatedContentImages/related-driveup-1.webp";
import Related2 from "assets/images/psp/relatedContentImages/related-driveup-2.webp";
import Related3 from "assets/images/psp/relatedContentImages/related-driveup-3.webp";
import HeaderBackgroundDesktop from "assets/images/psp/hero/drive-up-hero.webp";
import HeaderBackgroundMobile from "assets/images/psp/hero/drive-up-header-mobile.webp";
import HeaderBackgroundTablet from "assets/images/psp/hero/drive-up-header-tablet.webp";
import { storageCategories } from "pages/PSPPage/utils/getPSPLinks";

const reviews = {
	title: "Storage.com has a 4.4 out of 5 star rating on",
	testimonials: [
		{
			body: "The person from Storage.com who assisted me was super helpful and offered several options. I saved a lot of money because of the great deals your company could offer, which were below market rate if I had dealt directly with the storage company.",
			author: "Pasadena Garden Club",
			title: "The person who assisted me was super…",
			imageSrc: GeorgeRansom
		},
		{
			body: "Abby, the customer service representative at storage.com, was professional, helpful and friendly. She found me a storage space at an excellent price in close proximity to my home. I can't thank her enough.",
			author: "Ann Alarcon",
			title: "A wonderful experience",
			imageSrc: AnnAlarcon
		},
		{
			body: "It was very easy to find storage close to me, and the selection was all mine. I was very happy with this process.",
			author: "Dale Howard",
			title: "Finding Storage",
			imageSrc: SMurphy
		}
	]
};

const faqs = [
	{
		question: "What is drive-up storage access?",
		answer: "Drive-up access means your storage unit is located on the ground level, allowing you to park your vehicle directly in front of the unit door. Like a garage, you can load and unload items straight from your vehicle into the unit without using elevators or navigating interior hallways."
	},
	{
		question: "Is drive-up storage more expensive?",
		answer: "Drive-up storage units typically cost $10–30 more per month than comparable upper-floor units due to their convenience and higher demand. However, the time and effort saved—especially when moving heavy items or accessing your unit frequently—often makes the additional cost worthwhile for many renters."
	},
	{
		question: "Can I get climate-controlled drive-up units?",
		answer: "Yes, many [facilities offer climate-controlled drive-up storage](https://www.storage.com/blog/climate-controlled-storage-units/) combining ground-level convenience with temperature and humidity regulation. These units are ideal for storing items sensitive to weather extremes while maintaining easy vehicle access—perfect for electronics, furniture, and business documents."
	},
	{
		question: "What size drive-up unit do I need?",
		answer: "The size you need depends on what you're storing. A 10x10 drive-up unit typically fits the contents of a one-bedroom apartment, while a 10x20 unit can accommodate larger vehicles or multi-room furniture. Measure your items in advance and allow an extra 2–3 feet for walking and maneuvering space."
	},
	{
		question: "Are drive-up units good for business storage?",
		answer: "Absolutely. Drive-up storage is ideal for contractors, landscapers, and small businesses that require frequent access to tools, equipment, or inventory. Being able to pull up directly to your unit saves time and increases efficiency compared to navigating multi-level indoor facilities."
	}
];

const relatedContentCards = [
	{
		category: "Self Storage",
		url: "https://www.storage.com/blog/what-is-drive-up-storage/",
		date: "September 26, 2025",
		image: Related1,
		content: "What is Drive-Up Storage?"
	},
	{
		category: "Self Storage",
		url: "https://www.storage.com/blog/drive-up-vs-first-floor-access-self-storage/",
		date: "June 2, 2025",
		image: Related2,
		content:
			"First Floor Storage vs Drive Up Storage: Your Complete Guide to Ground Level Storage Units"
	},
	{
		category: "Self Storage",
		url: "https://www.storage.com/blog/10-items-that-need-climate-controlled-storage/",
		date: "October 16, 2025",
		image: Related3,
		content: "What Needs Climate Controlled Storage"
	}
];

const driveUpHerodescription = `Load and unload with ease using convenient drive-up storage units near you. From [storing vehicles and heavy equipment](https://www.storage.com/blog/construction-equipment-storage-solutions/), to bulky furniture, drive-up access eliminates stairs, elevators, and long hallways. Drive right to your unit door for effortless loading, making drive-in storage units the practical choice for anyone who values convenience and wants to minimize the hassle of moving items in and out of storage.`;

export const PSPDriveUpContent = {
	type: "Drive Up",
	sections: [
		{
			title: "Drive Up Storage hero",
			noPadding: true,
			modules: [
				{
					type: "hero-section",
					props: {
						title: "Find the Top Drive Up Storage Units",
						description: driveUpHerodescription,
						searchPlaceholder: "Search by city, state, or zip...",
						buttonText: "Find Drive-Up Storage",
						heroImages: {
							desktop: HeaderBackgroundDesktop,
							tablet: HeaderBackgroundTablet,
							mobile: HeaderBackgroundMobile
						},
						heroAltText: "Drive Up Storage Hero Image"
					}
				}
			]
		},
		{
			title: "Drive Up content module",
			noPadding: true,
			modules: [
				{
					type: "content-section",
					props: {
						title: "The Convenience of Drive-Up Storage Units",
						background: "light-blue",
						content: [
							{
								id: "1",
								value: "Drive-up storage units provide ground-level access where you can park directly in front of your unit door. This garage-style configuration eliminates the need to navigate through buildings or transport items long distances, making drive-up storage unit access ideal for anyone storing heavy, bulky, or frequent-access items."
							},
							{
								id: "2",
								value:
									"**Benefits of Drive-Up Access Storage**\n" +
									"- Loading and unloading made easy\n" +
									"- Vehicle storage is as simple as pulling in and parking\n" +
									"- Heavy items have a place to stay, and you won’t break your back putting them there\n" +
									"- Business and contractor friendly spaces enable smooth trips in and out\n" +
									"- Climate-controlled drive-up storage is often available for added convenience and protection"
							}
						],
						isColumnWise: false
					}
				}
			]
		},
		{
			title: "Drive Up Storage",
			noPadding: true,
			modules: [
				{
					type: "video-content",
					props: {
						title: "What Can You Store in Drive-Up Units?",
						description:
							"Drive-up storage gives users added convenience for loading and unloading, making it a popular choice for storing items big and small. ",
						mediaType: "video",
						mediaUrl: "OVr1uo_kkZU",
						videoTitle: "What Can You Store in Drive-Up Units?"
					}
				}
			]
		},
		{
			title: "Drive Up Storage Size Comparison",
			noPadding: true,
			modules: [
				{
					type: "size-comparison",
					props: {
						title: "How Much Do Drive-Up Storage Units Cost?",
						description:
							"Storage units with drive-up access pricing varies by location, size, and features. Compare current rates on Storage.com to find the best drive-in storage option near you.\n\n Here’s what you can expect based on 2025 averages: ",

						sizes: [
							{
								id: "5x10",
								label: "5x10",
								title: "5' Wide x 10' Long",
								description:
									"* $50 - $120/month\n*  Seasonal items, small equipment"
							},
							{
								id: "10x10",
								label: "10x10",
								title: "10' Wide x 10' Long",
								description:
									"* $80 - $160/month\n*  Furniture, [business supplies](https://www.storage.com/blog/e-commerce-storage/), single vehicle"
							},
							{
								id: "10x15",
								label: "10x15",
								title: "10' Wide x 15' Long",
								description:
									"* $110 - $200/month\n*  Vehicles, multiple rooms of furniture"
							},
							{
								id: "10x20",
								label: "10x20",
								title: "10' Wide x 20' Long",
								description:
									"* $130 - $250/month\n*  Boats, RVs, commercial equipment"
							},
							{
								id: "10x30",
								label: "10x30",
								title: "10' Wide x 30' Long",
								description:
									"* $180 - $350/month\n*  Large vehicles, extensive inventory"
							}
						]
					}
				}
			]
		},
		{
			title: "Drive Up Storage",
			noPadding: true,
			modules: [
				{
					type: "inline-cta",
					props: {
						storageType: "Drive Up"
					}
				}
			]
		},
		{
			title: "Drive Up Customer Reviews",
			noPadding: true,
			modules: [
				{
					type: "reviews",
					props: reviews
				}
			]
		},
		{
			title: "Drive Up Storage FAQs",
			noPadding: true,
			modules: [
				{
					type: "faq",
					props: {
						title: "Drive Up Storage FAQs",
						faqs
					}
				}
			]
		},
		{
			title: "Drive Up Storage Related Content",
			noPadding: true,
			modules: [
				{
					type: "related-content",
					props: {
						heading: "Learn More About Drive Up Storage",
						unitCards: relatedContentCards
					}
				}
			]
		},
		{
			title: "Drive Up Links to other PSP",
			noPadding: true,
			modules: [
				{
					type: "psp-links",
					props: {
						background: "white",
						storageGridContent: {
							title: "More Ways to Store",
							storageTypes: storageCategories.driveUpAccess
						}
					}
				}
			]
		},
		{
			title: "Drive Up Storage Near You",
			noPadding: true,
			modules: [
				{
					type: "nearby-cities",
					props: {
						pageType: "PSP",
						background: "light-blue"
					}
				}
			]
		}
	]
};

export default PSPDriveUpContent;
